import { environment } from "../environment";
import { ElectionResult } from "../models/ballotBox";
import { AsyncResult } from "../models/common/async-result";
import { BallotBox, Candidate, Election } from "../models/vote";
import api from "./api";

export async function getElectionsByUserId(userId: number, isFinish, type: 'meet' | 'book'): Promise<Election[]> {
  const url = environment.api.elections.getUserElection
    .replace('{isFinish}', String(isFinish || 0))
    .replace('{userId}', String(userId))
    .replace('{type}', String(type))

  const response = await api.get(url)
    .then(resp => resp?.data.success)
    .catch(error => error.response.data);

  return response.success as Election[];
}


export async function getElection(electionId: number): Promise<Election> {
  const url = environment.api.elections.get
    .replace('{electionId}', String(electionId))

  const response = await api.get(url)
    .then(resp => resp?.data.success)
    .catch(error => error.response.data);

  return response as Election;
}

export async function getUserElections(userId: number, type: 'meet' | 'book' | '', time: string): Promise<Election[]> {
  let baseUrl = environment.api.elections.getUserElection

  const url = baseUrl
    .replace('{userId}', String(userId))
    .replace('{type}', String(type || ''))
    .replace('{time}', String(time || ''))

  const response = await api.get(url)
    .then(resp => resp?.data.success)
    .catch(error => []);

  return response as Election[];
}

export async function getClubElections(clubId: number, type: 'meet' | 'book' | '', time: string): Promise<Election[]> {
  let baseUrl = environment.api.elections.getClubElection

  const url = baseUrl
    .replace('{clubId}', String(clubId))
    .replace('{type}', String(type || ''))
    .replace('{time}', String(time || ''))

  const response = await api.get(url)
    .then(resp => resp?.data.success)
    .catch(error => []);

  return response as Election[];
}

export async function getUserVoteByUserAndElectionId(userId: number, electionId: number): Promise<BallotBox> {
  const url = environment.api.elections.ballotBox.getUserVote
    .replace('{userId}', String(userId))
    .replace('{electionId}', String(electionId))

  const response = await api.get(url)
    .then(resp => resp?.data.success)
    .catch(error => null);

  return response
}

export async function getElectionResult(electionId: number): Promise<ElectionResult[]> {
  const url = environment.api.elections.getResults
    .replace('{electionId}', String(electionId))

  const response = await api.get(url)
    .then(resp => resp?.data.success)
    .catch(error => []);

  return response
}

export async function getCandidatesByElectionId(electionId: number): Promise<Candidate[]> {
  const baseUrl = environment.api.elections.candidates.getAll
    .replace('{electionId}', String(electionId))

  const url = baseUrl
    .replace('/user/{userId}', '')

  const response = await api.get(url)
    .then(resp => resp?.data.success)
    .catch(error => null);

  return response
}

export async function createElection(clubId: number, userId: number, payload): Promise<AsyncResult<any>> {
  const baseUrl = environment.api.elections.create
    .replace('{clubId}', String(clubId))
    .replace('{userId}', String(userId))

  const response = await api.post(baseUrl, payload)
    .then(resp => { return { success: resp.data.success, error: void 0 } })
    .catch((err) => { return { success: void 0, error: err.response.data.error } });

  if (response.error) return { error: response.error }

  return { success: response.success };
}

export async function insertVote(electionId: number, userId: number, candidateId: number): Promise<AsyncResult<any>> {
  const baseUrl = environment.api.elections.ballotBox.insert
    .replace('{electionId}', String(electionId))
    .replace('{userId}', String(userId))
    .replace('{candidateId}', String(candidateId))

  const response = await api.post(baseUrl)
    .then(resp => { return { success: resp.data.success, error: void 0 } })
    .catch((err) => { return { success: void 0, error: err.response.data.error } });

  if (response.error) return { error: response.error }

  return { success: response.success };
}

export async function deleteVote(electionId: number, userId: number, candidateId: number): Promise<AsyncResult<any>> {
  const baseUrl = environment.api.elections.ballotBox.delete
    .replace('{electionId}', String(electionId))
    .replace('{userId}', String(userId))
    .replace('{candidateId}', String(candidateId))

  const response = await api.delete(baseUrl)
    .then(resp => { return { success: resp.data.success, error: void 0 } })
    .catch((err) => { return { success: void 0, error: err.response.data.error } });

  if (response.error) return { error: response.error }

  return { success: response.success };
}